import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Avatar,
    Link,
    Button
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const tipsLeft = [
    'Describe el problema con detalle',
    'Incluye capturas de pantalla'
];
const tipsRight = [
    'Menciona los pasos para reproducir el error',
    'Indica la urgencia del problema'
];

const RecommendedTips: React.FC = () => {
    return (
        <Box mt={3}>
            <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                Recomendado para ti
            </Typography>

            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: '#F5F6FF',
                    border: '1px solid #E0E7FF'
                }}
            >
                <Grid container spacing={2} alignItems="center">
                    {/* Icono */}
                    <Grid xs={12} md={1}>
                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                            <Avatar
                                sx={{
                                    bgcolor: '#007bff',
                                    width: 34,
                                    height: 34
                                }}
                            >
                                <HelpOutlineIcon fontSize="large" />
                            </Avatar>
                        </Box>
                    </Grid>

                    {/* Contenido */}
                    <Grid xs={12} md={11}>
                        <Box>
                            {/* Título + enlace */}
                            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                <Typography fontWeight="bold">
                                    Cómo levantar un ticket de soporte
                                </Typography>
                            </Box>
                            <br></br>
                            {/* Tips y botón en columnas */}
                            <Grid container spacing={2}>
                                {/* Columna izquierda */}
                                <Grid xs={12} md={6}>
                                    {tipsLeft.map((tip, index) => (
                                        <Box display="flex" alignItems="center" mb={0.75} key={index}>
                                            <CheckCircleIcon
                                                fontSize="small"
                                                sx={{ color: '#007bff', mr: .5 }}
                                            />
                                            <Typography variant="body2">{tip}</Typography>
                                        </Box>
                                    ))}

                                    {/* Botón alineado a la izquierda */}
                                    
                                </Grid>

                                {/* Columna derecha */}
                                <Grid xs={12} md={6}>
                                    {tipsRight.map((tip, index) => (
                                        <Box display="flex" alignItems="center" mb={0.75} key={index}>
                                            <CheckCircleIcon
                                                fontSize="small"
                                                sx={{ color: '#007bff', mr: 1 }}
                                            />
                                            <Typography variant="body2">{tip}</Typography>
                                        </Box>
                                    ))}
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    );
};

export default RecommendedTips;
